{
  "close": "Закрити",
  "notifications": "Сповіщення"
}
